import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const postCommentReplyEditApi = createAsyncThunk(
    'auth/postCommentReplys/Edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.publicapiAction(`edit_comment_reply`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const postCommentReplyEditSlice = createSlice({
    name: 'postCommentReply Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(postCommentReplyEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(postCommentReplyEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(postCommentReplyEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const postCommentReplyEditReducer = postCommentReplyEditSlice.reducer